import { Grid, Typography, makeStyles } from "@material-ui/core";
import React from "react";
import GuideComponent from "../../../components/materialui/Shared/GuideComponent"
import GuideIMG from "../../../../assets/guide.png";


const useStyles = makeStyles(() => ({

    message: {
        fontSize: '1em',
        color: '#000',
        fontWeight: 'lighter',
    },

    documentItem: {
        fontSize: '0.8em',
        color: '#231F20',
        font: 'Inter',
        fontWeight: 'lighter',
    },

    image: {
        width: '40%',
        display: "block",
        margin: "0 auto"
    },
}));


export default function GuideStep() {

    const classes = useStyles();

    return (
        <div>
            <GuideComponent title="Guia de documentação">
                <Grid container spacing={2}>

                    <Grid item xs={12}>
                        <Grid container>
                            <Grid item sm={12}>
                                <img src={GuideIMG} className={classes.image} alt="Imagem ilustativa do guia" />
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="body1" className={classes.message}>
                            Antes de iniciar o preenchimento do formulário, tenha em mãos os seguintes documentos que deverão ser anexados a solicitação:
                        </Typography>
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="body1" component="span" className={classes.message}>
                            <p><strong>Instrumentador e Perfusionista</strong></p>
                        </Typography>
                        <Typography variant="body2" component="span" className={classes.documentItem}>
                            <p> - Atestado de Capacidade Física e Cognitva; </p>
                            <p> - Carta de apresentação da empresa ou do médico titular da equipe com justificativa da solicitação e se
                                co-responsabilizando pelo profissional a ser cadastrado.  </p>
                            <p> - Carteira de Vacinação atualizada ou termo de recusa; </p>
                            <p> - Certificado de área de Atuação e ou Diploma Graduação Profissional <strong>(Frente e Verso);</strong></p>
                            <p> - Comprovante de Vacinação COVID19; </p>
                            <p> - Currículo resumido atualizado; </p>
                            <p> - Declaração de conflito;( exceto para instrumentadores de empresa) </p>
                            <p> - Foto fundo branco; </p>
                            <p> - RG e CPF; </p>
                        </Typography>
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="body1" component="span" className={classes.message}>
                            <p><strong>Enfermeiro(a), Fisioterapeuta, Fonoaudiólogo(a), Nutricionista, Psicólogo (a), Terapeuta Ocupacional</strong></p>
                        </Typography>
                        <Typography variant="body2" component="span" className={classes.documentItem}>
                            <p> - Atestado de Capacidade Física e Cognitva;  </p>
                            <p> - Carta de apresentação da empresa ou do médico titular da equipe com justificativa da solicitação e se
                                co-responsabilizando pelo profissional a ser cadastrado.  </p>
                            <p> - Carteira de Vacinação atualizada ou termo de recusa; </p>
                            <p> - Carteira do Conselho Profissional; </p>
                            <p> - Comprovante do pagamento da anuidade do Conselho Profissional;</p>
                            <p> - Comprovante de Vacinação COVID19; </p>
                            <p> - Currículo resumido atualizado;  </p>
                            <p> - Declaração de conflito; </p>
                            <p> - Diploma Graduação Profissional <strong> (Frente e Verso);</strong>  </p>
                            <p> - Foto fundo branco;  </p>
                            <p> - RG e CPF; </p>
                            <p> - Título de Especialista ou Residência, ou certificado de pós-graduação <strong> (Frente e Verso);</strong> </p>    
                        </Typography>
                    </Grid>

                </Grid>
            </GuideComponent>
        </div>

    )
}